var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center flex-wrap mt-3"},[_c('div',{staticClass:"col-12 text-center"},[_c('b-img',{staticClass:"img-empty-campaign mb-3",attrs:{"src":_vm.emptyStateImage}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }